
































































































































































































































































import Vue from 'vue'
import getStoriesFeatured from '~/apollo/queries/getStoriesFeatured.gql'
import getStory from '~/apollo/queries/getStory.gql'
import getStoryNext from '~/apollo/queries/getStoryNext.gql'
import getStoryNextCategory from '~/apollo/queries/getStoryNextCategory.gql'
import getStoryPrevious from '~/apollo/queries/getStoryPrevious.gql'
import getStoryPreviousCategory from '~/apollo/queries/getStoryPreviousCategory.gql'
import ShareButton from '~/components/ShareButton.vue'
import StoryGallery from '~/components/StoryGallery.vue'
import StoryLayout1 from '~/components/StoryLayout1.vue'
import StoryLayout2 from '~/components/StoryLayout2.vue'
import StoryLayout3 from '~/components/StoryLayout3.vue'
import StoryLayout4 from '~/components/StoryLayout4.vue'
import SvgImage from '~/components/SvgImage.vue'

export default Vue.extend({
  name: 'Story',
  components: {
    ShareButton,
    StoryGallery,
    StoryLayout1,
    StoryLayout2,
    StoryLayout3,
    StoryLayout4,
    SvgImage
  },
  async fetch () {
    const storyQuery = await this.$apolloProvider.defaultClient.query({
      query: getStory,
      variables: {
        slug: this.$route.params.slug
      }
    })
    this.story = storyQuery.data.story

    if (this.story) {
      const tmpImages = Array.from(this.story.image)
      tmpImages.reverse()
      this.storyMedia.push(this.story.video1 ? this.story.video1 : tmpImages.pop())
      this.storyMedia.push(this.story.video2 ? this.story.video2 : tmpImages.pop())
      this.storyMedia.push(this.story.video3 ? this.story.video3 : tmpImages.pop())
      this.storyMedia.push(this.story.video4 ? this.story.video4 : tmpImages.pop())
      this.storyMedia.push(this.story.video5 ? this.story.video5 : tmpImages.pop())
      this.storyMedia = this.storyMedia.filter(function (el: any) { return el !== undefined })

      while (tmpImages.length > 0) {
        this.storyMedia.push(tmpImages.pop())
      }

      const nextStoryQuery = await this.$apolloProvider.defaultClient.query({
        query: getStoryNext,
        variables: {
          currentId: storyQuery.data.story.id,
          categorySlug: storyQuery.data.story.eventCategory.slug
        }
      })
      this.nextStory = nextStoryQuery.data.story[0]

      if (!this.nextStory) {
        const getStoryNextCategoryQuery = await this.$apolloProvider.defaultClient.query({
          query: getStoryNextCategory,
          variables: {
            categoryId: storyQuery.data.story.eventCategory.id
          }
        })
        this.nextStory = getStoryNextCategoryQuery.data.category[0]?.story[0]
      }

      const previousStoryQuery = await this.$apolloProvider.defaultClient.query({
        query: getStoryPrevious,
        variables: {
          currentId: storyQuery.data.story.id,
          categorySlug: storyQuery.data.story.eventCategory.slug
        }
      })
      this.previousStory = previousStoryQuery.data.story[0]

      if (!this.previousStory) {
        const getStoryPreviousCategoryQuery = await this.$apolloProvider.defaultClient.query({
          query: getStoryPreviousCategory,
          variables: {
            categoryId: storyQuery.data.story.eventCategory.id
          }
        })
        this.previousStory = getStoryPreviousCategoryQuery.data.category[0]?.story[0]
      }

      const featuredStoriesQuery = await this.$apolloProvider.defaultClient.query({
        query: getStoriesFeatured
      })
      this.featuredStories = featuredStoriesQuery.data.stories
    }
  },
  data () {
    return {
      story: null as any,
      storyMedia: [] as any,
      nextStory: null as any,
      previousStory: null,
      featuredStories: null,
      showPreviousStory: false,
      showNextStory: false,
      loadingTimer: 8,
      loadingNext: false,
      timeouts: [] as any
    }
  },
  computed: {
    currentUrl (): String {
      if (process.client) {
        return window.location.href
      }

      return ''
    }
  },
  mounted () {
    if (!this.$fetchState.pending) {
      if (!this.story) {
        this.$router.push({ path: '/stories' })
      }
    }

    window.addEventListener('scroll', this.checkIfWindowBottom)
  },
  destroyed () {
    window.removeEventListener('scroll', this.checkIfWindowBottom)

    this.timeouts.forEach((e: any) => {
      clearTimeout(e)
    })
  },
  methods: {
    checkIfWindowBottom () {
      if (process.client) {
        const bottomOfWindow = (Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight + 5) > (document.documentElement.offsetHeight - 350)

        if (bottomOfWindow && this.nextStory) {
          this.timeouts.push(setTimeout(() => {
            this.loadingNext = true
            this.startTimer()
          }, 1500))
        }
      }
    },
    showHidePreviousStory (show: boolean) {
      this.showPreviousStory = show
      this.showNextStory = false
    },
    showHideNextStory (show: boolean) {
      this.showNextStory = show
      this.showPreviousStory = false
    },
    documentClick () {
      this.showNextStory = false
      this.showPreviousStory = false
    },
    startTimer () {
      if (this.loadingTimer > 0) {
        this.timeouts.push(setTimeout(() => {
          this.loadingTimer -= 1
          this.startTimer()
        }, 1000))
      } else {
        this.$router.push({ path: `/stories/${this.nextStory.slug}` })
      }
    }
  },
  head (): any {
    return {
      title: this.story ? this.story.metaTitle : '',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: this.story ? this.story.metaDescription : ''
        }
      ]
    }
  }
})
